import styled from 'styled-components';
import Link from 'components/Link';
import Button from 'components/Button';
import Title from 'components/Title';

export const ShareWidgetStyled = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  width: 100%;
  z-index: 2;
`;

export const ShareWrapper = styled.div`
  position: relative;
  width: 400px;
  padding: 40px 32px 32px;
  border-radius: 10px;
  background-color: white;
  z-index: 2;
`;

export const Overlay = styled.div`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
`;

export const ShareByTimeWrap = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  margin-top: 8px;
  align-items: center;
  padding: 9px 0;
`;

export const SocialWrap = styled.div`
  margin-top: 24px;
`;

export const SocialContainer = styled.div`
  position: relative;
  width: 100%;
  margin-top: 8px;
  display: flex;
  justify-content: flex-start;
  gap: 8px;
`;

export const StyledLink = styled(Link)`
  color: white !important;
  width: 100%;
  border-radius: 8px;
  height: 48px;
`;

export const StyledButton = styled(Button)`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1;
`;

export const StyledTitle = styled(Title)`
  font-size: 32px;
  margin-bottom: 24px;
`;
